import { render, staticRenderFns } from "./VIPApplyRefund.vue?vue&type=template&id=6720ce88&scoped=true&"
import script from "./VIPApplyRefund.vue?vue&type=script&lang=js&"
export * from "./VIPApplyRefund.vue?vue&type=script&lang=js&"
import style0 from "./VIPApplyRefund.vue?vue&type=style&index=0&id=6720ce88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720ce88",
  null
  
)

export default component.exports